<template>
  <div class="repair-country-wrap flex">
    <div class="country-left">
      <div class="country-left-title">全部</div>
      <ul class="country-left-ul">
        <li class="">
          <a class="active" href="javascript:void(0)"
            ><i class="iconfont icon-file-text-o"></i>流程指引</a
          >
        </li>
        <li class="">
          <a href="https://www.creditchina.gov.cn/xyxf/xfzn/" target="_blank"
            ><i class="iconfont icon-file-text-o"></i>修复指南</a
          >
        </li>
        <li class="">
          <a href="https://www.creditchina.gov.cn/xyxf/xcslwd/" target="_blank"
            ><i class="iconfont icon-search"></i>现场受理网点</a
          >
        </li>
        <li class="">
          <a href="https://www.creditchina.gov.cn/xyxf/gyxxy/" target="_blank"
            ><i class="iconfont icon-file-text-o"></i
            >公益性信用修复培训及报告</a
          >
        </li>
        <li class="">
          <a href="https://www.creditchina.gov.cn/pxpt/" target="_blank"
            ><i class="iconfont icon-file-text-o"></i
            >“信用中国”网站公益性在线培训平台</a
          >
        </li>
        <li class="">
          <a
            href="https://www.creditchina.gov.cn/xyxf/xfpxjgmd/"
            target="_blank"
            ><i class="iconfont icon-search"></i>信用修复培训机构名单</a
          >
        </li>
        <li class="">
          <a
            href="https://www.creditchina.gov.cn/xyxf/xygbfwjgmd/"
            target="_blank"
            ><i class="iconfont icon-search"></i>信用报告服务机构名单</a
          >
        </li>
        <li class="">
          <a
            href="https://public.creditchina.gov.cn/htmls/repair/repairSearch.html"
            target="_blank"
            ><i class="iconfont icon-search"></i>修复进度自助查询</a
          >
        </li>
        <li class="">
          <a href="https://www.creditchina.gov.cn/xyxf/cjwd/" target="_blank"
            ><i class="iconfont icon-file-text-o"></i>常见问答</a
          >
        </li>
      </ul>
    </div>

    <div class="country-right">
      <div class="country-title">
        <img src="@/static/images/repair/sm.png" class="circle" alt="" />
        <h3>信用修复说明</h3>
        <p>
          仅在信用中国（山东）网站公示的行政处罚信息，信用修复政策执行《失信行为纠正后的信用信息修复管理办法（试行）》（国家发展改革委令第58号）。行政相对人在提交修复申请前，请认真阅读修复指南和流程指引，将加盖单位公章的
          《信用中国（山东）网站行政处罚信息公示提前撤销申请表》连同修复相关材料扫描并发送至邮箱creditsd@shandong.cn。信用修复申请受理后，我们将在5个工作日内办结并反馈。
        </p>
      </div>
      <div class="lczyStep">
        <div style="display: flex">
          <div
            class="stepbox"
            v-bind:class="{ active: step1 }"
            @mouseover="instep1"
          >
            第一步
            <div v-bind:class="{ arrow: !step1, arrowActive: step1 }"></div>
          </div>
        </div>
        <div style="display: flex">
          <div
            class="stepbox"
            v-bind:class="{ active: step2 }"
            @mouseover="instep2"
          >
            第二步
            <div v-bind:class="{ arrow: !step2, arrowActive: step2 }"></div>
          </div>
        </div>
        <div style="display: flex">
          <div
            class="stepbox"
            v-bind:class="{ active: step3 }"
            @mouseover="instep3"
          >
            第三步
            <div v-bind:class="{ arrow: !step3, arrowActive: step3 }"></div>
          </div>
        </div>
      </div>
      <div class="lczystepcont lczystep-1" v-show="step1">
        <h3>查看主体的相关行政处罚信息</h3>
        <p class="small-t">
          <span>1</span>
          在“信用中国（山东）网站”首页左侧的<em class="blue_text"
            >“快捷服务”栏目</em
          >
          处，点击<em class="blue_text">“信用中国（山东）信息查询”</em>。
        </p>
        <img src="../../static/images/repair/1-1.png" style="width: 1000px" />
        <p class="small-t">
          <span>2</span>
          在“信用中国（山东）信息查询”页面，输入主体名称、统一社会信用代码或者工商注册号，点击<em
            class="blue_text"
            >立即查询”</em
          >
          ，找到所查询主体。
        </p>
        <img src="../../static/images/repair/1-2.png" style="width: 1000px" />
        <p class="small-t">
          <span>3</span>
          在“信用信息详细”页面上，找到并点击<em class="blue_text"
            >“行政处罚信息”</em
          >
          分类，即可看到该主体相关行政处罚信息。
        </p>
        <img src="../../static/images/repair/1-3.png" style="width: 1000px" />
      </div>

      <div class="lczystepcont lczystep-2" v-show="step2">
        <h3>准备相关材料</h3>
        <table border="0" cellpadding="0" cellspacing="0">
          <tr>
            <td>材料一：</td>
            <td>
              <p>
                《失信行为纠正后的信用信息修复业务办理授权委托书》或者《法定代表人身份证明书》
              </p>
            </td>
          </tr>
          <tr>
            <td>材料二：</td>
            <td>
              <p>
                市场监督管理领域的行政处罚由市场监督管理部门出具《准予信用修复决定书》或者其他准予信用修复的证明材料等；
              </p>
              <p>
                其他行政处罚由处罚机关出具《失信行为纠正后的信用信息修复申请表》，或者其他可说明相关责任义务已履行完毕的材料，如缴交罚款的收据、行政处罚机关出具的相关整改证明材料等；
              </p>
            </td>
          </tr>
          <tr>
            <td>材料三：</td>
            <td>
              <p>《失信行为纠正后的信用信息修复承诺书》</p>
            </td>
          </tr>
        </table>
        <dl class="cailiao">
          <dt>材料一</dt>
          <dd>
            <p style="border-bottom: 1px dashed #d9d9d9">
              失信行为纠正后的信用信息修复业务办理授权委托书.docx
              <a
                href="/static/repair/newcailiao1-1.docx"
                class="blue_text"
                download="失信行为纠正后的信用信息修复业务办理授权委托书.docx"
                >模板下载</a
              >
            </p>
          </dd>
          <dd>
            <p>
              法定代表人身份证明书.docx
              <small>
                (<em class="red_text">仅限</em>
                法定代表人申请行政处罚信息信用修复时使用)
              </small>
              <a
                href="/static/repair/newcailiao1-2.docx"
                class="blue_text"
                download="法定代表人身份证明书.docx"
                >模板下载</a
              >
            </p>
          </dd>
        </dl>
        <dl class="cailiao">
          <dt>材料二</dt>
          <dd>
            <p style="border-bottom: 1px dashed #d9d9d9">
              失信行为纠正后的信用信息修复申请表.docx
              <a
                href="/static/repair/newcailiao2-1.docx"
                class="blue_text"
                download="失信行为纠正后的信用信息修复申请表.docx"
                >模板下载</a
              >
            </p>
          </dd>
          <dd>
            <p>
              准予信用修复决定书.docx
              <small>
                (<em class="red_text">仅限</em>
                申请修复市场监督管理领域的行政处罚信息使用)
              </small>
              <a
                href="/static/repair/newcailiao2-2.docx"
                class="blue_text"
                download=" 准予信用修复决定书.docx"
                >模板下载</a
              >
            </p>
          </dd>
        </dl>
        <dl class="cailiao">
          <dt>材料三</dt>
          <dd>
            <p>
              失信行为纠正后的信用信息修复承诺书.docx
              <a
                href="/static/repair/newcailiao3.docx"
                class="blue_text"
                download="失信行为纠正后的信用信息修复业务办理授权委托书.docx"
                >模板下载</a
              >
            </p>
          </dd>
        </dl>
      </div>

      <div class="lczystepcont lczystep-3" v-show="step3">
        <h3>提交修复申请</h3>
        <p class="small-t">
          将加盖单位公章的
          《信用中国（山东）网站行政处罚信息公示提前撤销申请表》连同修复相关材料扫描并发送至邮箱creditsd@shandong.cn。信用修复申请受理后，我们将在5个工作日内办结并反馈。
        </p>
        <h3>修复申请表模板下载</h3>
        <p class="small-t">
          <a
            style="color: #0063ba"
            href="/static/repair/20220424172635114.docx"
            download="信用中国（山东）网站行政处罚信息公示提前撤销申请表.docx"
            >信用中国（山东）网站行政处罚信息公示提前撤销申请表</a
          >
        </p>
        <h3>咨询电话</h3>
        <p class="small-t">0531-51785749、51783703</p>
      </div>
    </div>
  </div>
</template>

<script>
import process from "@/components/process";
export default {
  components: {
    process,
  },
  data() {
    return {
      step1: true,
      step2: false,
      step3: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    instep1() {
      this.step1 = true;
      this.step2 = false;
      this.step3 = false;
      this.step4 = false;
      this.step5 = false;
    },
    instep2() {
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
      this.step4 = false;
      this.step5 = false;
    },
    instep3() {
      this.step1 = false;
      this.step2 = false;
      this.step3 = true;
      this.step4 = false;
      this.step5 = false;
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.repair-country-wrap {
  width: 100%;
  align-items: flex-start;

  .country-left {
    width: 180px;
    flex-shrink: 0;
    font-size: 14px;
    padding: 0;
    margin-top: 46px;
    .country-left-title {
      font-size: 20px;
      font-weight: normal;
      border-bottom: 1px solid #dddddd;
      padding-bottom: 12px;
    }
    .country-left-ul {
      li {
        list-style: none;
        padding: 17px 0 17px 25px;
        border-bottom: 1px solid #dddddd;
        cursor: pointer;
        a {
          letter-spacing: 1px;
          color: #333;
          &.active {
            color: #e22323;
          }
          i.iconfont {
            font-size: 14px;
            display: inline-block;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .country-right {
    width: calc(100% - 180px);
    padding-left: 36px;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 22px;
    .country-title {
      color: #333;
      position: relative;
      h3 {
        font-size: 18px;
        line-height: 1.1;
        color: #000;
        margin-top: 20px;
        margin-bottom: 10px;
        margin-left: 50px;
        font-weight: 500;
      }
      p {
        text-indent: 2em;
        line-height: 28px;
        font-size: 16px;
        margin-top: 26px;
      }
      .circle {
        position: absolute;
        top: -3px;
        left: 15px;
        vertical-align: middle;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.lczyStep {
  display: flex;
  margin-top: 30px;
  overflow: hidden;
}
.lczyStep .active {
  background: linear-gradient(
    90deg,
    rgba(226, 35, 35, 1) 0%,
    rgba(198, 18, 18, 1) 100%
  );
  color: #fff;
  border: 0;
}
.stepbox {
  position: relative;
  float: left;
  width: 320px;
  height: 60px;
  border: 1px solid #000;
  border-radius: 4px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  margin-right: 50px;
}
.stepbox .arrow {
  content: "";
  position: absolute;
  right: -35px;
  top: 22px;
  width: 16px;
  height: 16px;
  background: url("../../static/images/repair/lczysteparr.png") left top
    no-repeat;
}
.stepbox .arrowActive {
  content: "";
  position: absolute;
  right: -35px;
  top: 22px;
  width: 16px;
  height: 16px;
  background: url("../../static/images/repair/lczysteparr-hover.png") left top
    no-repeat;
}

.lczystepcont {
  border: 1px solid #e22323;
  padding: 30px;
  margin-top: 38px;
  position: relative;
}
.lczystepcont:after {
  content: "";
  position: absolute;
  left: 140px;
  top: -17px;
  width: 37px;
  height: 18px;
  background: url("../../static/images/repair/lczystepcontarr.jpg") left top
    no-repeat;
}
.lczystepcont h3 {
  display: inline-block;
  font-size: 20px;
  color: #e22323;
  font-weight: bold;
  position: relative;
}

.lczystepcont h3:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 8px;
  width: 100%;
  background: rgba(226, 35, 35, 0.2);
}
.lczystepcont td {
  padding: 0;
  font-size: 16px;
  line-height: 28px;
  vertical-align: top;
  padding: 10px 0;
}
.lczystepcont td p {
  margin: 0;
  font-size: 16px;
  line-height: 28px;
}
.lczystepcont p {
  font-size: 16px;
  line-height: 28px;
  margin-top: 10px;
}

.lczystepcont p.small-t {
  margin-top: 20px;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 10px;
}

.lczystepcont p.small-t span {
  display: inline-block;
  width: 26px;
  height: 26px;
  background: #e22323;
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 26px;
  margin-right: 15px;
}
.lczystepcont p.small-t em.blue_text {
  color: #246bfb;
  font-style: normal;
  font-weight: normal;
}
.lczystepcont img {
  margin-top: 20px;
}
.lczystepcont table {
  width: 100%;
}

.lczystepcont table tr td:nth-child(1) {
  width: 8%;
}
.lczystepcont .cailiao dt {
  background: #e22323;
  display: inline-block;
  padding: 0 30px;
  font-size: 16px;
  color: #fff;
  height: 30px;
  line-height: 30px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.lczystepcont .cailiao dd {
  background: #ffffff;
  font-size: 16px;
  padding: 0 20px;
}

.lczystepcont .cailiao dd p {
  margin: 0;
  font-size: 16px;
  height: 65px;
  line-height: 65px;
  text-indent: 0;
}

.lczystepcont .cailiao dd p small {
  display: inline-block;
  margin-left: 30px;
  font-size: 12px;
}

.lczystepcont .cailiao dd p small em.red_text {
  color: #e22323;
  font-style: normal;
  font-weight: normal;
}

.lczystepcont .cailiao dd p a.blue_text {
  float: right;
  color: #246bfb;
  background: url("../../static/images/repair/lczydownload.png") left center
    no-repeat;
  padding-left: 25px;
  font-size: 14px;
}
.lczystepcont.lczystep-2:after {
  left: 510px;
}

.lczystepcont.lczystep-3:after {
  left: 880px;
}
</style>
